function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// Lib Imports
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box } from 'grommet';
import Select from 'granite-admin/core/components/Select';
import GraniteAPIClient from 'granite-admin/utils/granite-client';
const OrganisationSelector = ({
  dataSource,
  onChange,
  value,
  name,
  disabled,
  labelKey,
  valueKey,
  ...rest
}) => {
  const [options, setOptionsInDropdown] = useState([]);
  useEffect(() => {
    GraniteAPIClient('').get(dataSource).then(response => {
      const {
        data
      } = response;
      const opts = data?.results || data;
      setOptionsInDropdown(opts);
    }).catch(err => console.error(err));
  }, [dataSource]);
  return /*#__PURE__*/React.createElement(Box, {
    gap: "small",
    flex: {
      shrink: 0
    }
  }, /*#__PURE__*/React.createElement(Select, _extends({
    name: name,
    options: options,
    value: value,
    disabled: disabled,
    valueKey: valueKey,
    onChange: ({
      value
    }) => onChange(value)
    // onChange={console.log}
    ,
    labelKey: labelKey || 'label'
  }, rest)));
};
OrganisationSelector.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.any,
  name: PropTypes.string,
  disabled: PropTypes.any,
  labelKey: PropTypes.string,
  valueKey: PropTypes.string,
  dataSource: PropTypes.string
};
export default OrganisationSelector;